/*
 * This regex will match a string of numbers of any length - zero to n.
 * Note that a SIRET should be formatted as "NNN NNN NNN NNNNN".
 * As the length of numbers increases, the regex will progressively capture
 * a series of groups of numbers. The first three numbers will be captured
 * by the first group, the next set of numbers by the second and so on.
 * For any numbers longer than a standard SIRET, any further numbers will
 * be added to the final group (which should otherwise be only 4 digits long).
 *
 * This does not use the formatSIRET method provided by the 'vat-siren-siret'
 * library because it only returns a value for a complete and valid SIRET
 * number.
 */

const SIRET_REGEX = /^([\d]{0,3})([\d]{0,3})([\d]{0,3})([\d]{0,})$/;

const formatSIRET = (value: string): string => {
  const matches = value.match(SIRET_REGEX);
  if (matches === null) {
    return '';
  }
  return `${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]}`.trim();
};

export default formatSIRET;
